// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__21lxm","head":"Table_head__1K39e","col":"Table_col__hC-er"};